import React from 'react'
import Modal from '../../../../basic/Modal'
import InputText from '../../../../basic/InputText.js'
import {compose, withState} from 'recompose'
import Button from "../../../../basic/button";
import {validateEmail} from "../../../utils";
import requestPriceList from '../requestPriceList'
import MenuCloseButton from '../../../../static/menuCloseButtonB.svg'
import TranslateText from 'src/text/modal'


const textStyle = {
  width: 350,
  height: 54,
  margin: 5,
  background: 'transparent',
  border: '1px solid rgba(0,0,0,0.25)',
}

function PriceListRequestModal({company, setCompany, setTown, town, toggle, name, setName, phone, setPhone, email, setEmail, emailValid, setEmailValid}) {
  return (
    <Modal
      style={{
        background: 'rgba(0,0,0,0.75)',
        alignItems: 'start',
      }}
    >
      <div
        style={{
          background: 'white',
          border: '2px solid rgb(27, 36, 47)',
          textAlign: 'center',
          paddingTop: 10,
          paddingBottom: 30,
          paddingLeft: 40,
          paddingRight: 40,
          position: 'relative',
          marginTop: 100,
        }}
      >
        <img
          onClick={toggle}
          src={MenuCloseButton}
          style={{
            cursor: 'pointer',
            fontSize: 30,
            marginRight: 20,
            display: 'inline-block',
            position: 'absolute',
            right: -10,
            top: 10,
          }}
        />
        <div
          style={{
            fontSize: 30,
            marginTop: 40,
            fontWeight: 800,
          }}
        >
          <TranslateText
            id="search_modal__request_price"
            place="bottom"
          />
        </div>
        <div
          style={{
            marginTop: 30,
          }}
        >
          <div
            style={{
              display: 'block',
            }}
          >
            <TranslateText
              id="search_modal__request_fio"
              place="bottom"
              render={text => {
                return (
                  <InputText
                    placeholder={text}
                    value={name}
                    style={textStyle}
                    className={'input-text dark'}
                    onChange={(e) => {
                      setName(e.target.value)
                    }}
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: 'block',
              marginTop: 8,
            }}
          >
            <TranslateText
              id="search_modal__request_phone"
              place="bottom"
              render={text => {
                return (
                  <InputText
                    placeholder={text}
                    mask="+7 111 111-11-11"
                    className={'input-text dark'}
                    value={phone}
                    style={textStyle}
                    onChange={(e) => {
                      setPhone(e.target.value)
                    }}
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: 'block',
              marginTop: 8,
            }}
          >
            <TranslateText
              id="search_modal__request_email"
              place="bottom"
              render={text => {
                return (
                  <InputText
                    placeholder={text}
                    className={'input-text dark'}
                    value={email}
                    style={{
                      ...textStyle,
                      ...(!emailValid && {border: '4px solid red'}),
                    }}
                    onChange={(e) => {
                      const email = e.target.value
                      setEmail(e.target.value)
                      setEmailValid(!email || validateEmail(email))
                    }}
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: 'block',
              marginTop: 8,
            }}
          >
            <TranslateText
              id="search_modal__request_company"
              place="bottom"
              render={text => {
                return (
                  <InputText
                    placeholder={text}
                    className={'input-text dark'}
                    value={company}
                    style={textStyle}
                    onChange={(e) => {
                      setCompany(e.target.value)
                    }}
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: 'block',
              marginTop: 8,
            }}
          >
            <TranslateText
              id="search_modal__request_city"
              place="bottom"
              render={text => {
                return (
                  <InputText
                    placeholder={text}
                    className={'input-text dark'}
                    value={town}
                    style={textStyle}
                    onChange={(e) => {
                      setTown(e.target.value)
                    }}
                  />
                );
              }}
            />
          </div>
          <div
            style={{
              display: 'block',
              marginTop: 8,
            }}
          >
            <TranslateText
              id="search_modal__request_send"
              place="bottom"
              render={text => {
                return (
                  <Button
                    disabled={!name || !phone || !emailValid || !company || !town}
                    onClick={() => {
                      if (name && phone && emailValid && company && town) {
                        requestPriceList({
                          name,
                          phone,
                          email,
                          company,
                          town,
                          subject: 'Заявка на прайслист',
                        })
                        toggle()
                      }
                    }}
                  >
                    {text}
                  </Button>
                );
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

const enhance = compose(
  withState('name', 'setName', ''),
  withState('phone', 'setPhone', ''),
  withState('email', 'setEmail', ''),
  withState('emailValid', 'setEmailValid', true),
  withState('company', 'setCompany', ''),
  withState('town', 'setTown', ''),
)

export default enhance(PriceListRequestModal)


// WEBPACK FOOTER //
// ./src/finwhale/common/price-list-request/modal/Desktop.js